/**
 * The heat scale a column of durations is colored against.
 *
 * Shared by every table that colors its figures, because a reader moving
 * between them is comparing colors, and two scales that meant different things
 * would be worse than no color at all.
 *
 * Dark shades on purpose: a table where every number glows is a table nobody
 * reads, so these are meant to be noticed only when scanned for. Bright enough
 * to read at a glance, dark enough to stay legible on white.
 *
 * Low is green and high is red, because the scale colors durations and a long
 * one is the bad news. The scale reads the way the thing it describes does.
 */const HEAT_FAST=[56,146,82];// green, at the low end
const HEAT_MID=[176,137,36];// amber, legible where a true yellow is not
const HEAT_SLOW=[198,70,62];// red, at the high end
/**
 * A color for each value in a column, scaled against that column alone.
 *
 * The scale runs down a column, not across a row: a column is one statistic
 * measured the same way for every row, so its cells are comparable, where a
 * row mixes different statistics and coloring those against each other says
 * nothing.
 *
 * Returns a lookup rather than a list so a caller can color a cell without
 * having to remember where in the column it sat.
 */export function columnHeat(values){const present=[];for(const value of values){if(value!=null){present.push(value);}}if(present.length===0){return()=>undefined;}const low=Math.min(...present);const high=Math.max(...present);return value=>value==null?undefined:heatColor(value,low,high);}/**
 * Where `value` sits between `low` and `high`, as a color: green at the fast
 * end, amber in the middle, red at the slow end.
 *
 * A set whose values are all equal has no spread to place anything within, so
 * it takes the middle shade rather than an arbitrary end of the scale.
 */export function heatColor(value,low,high){if(!(high>low)){return mix(HEAT_MID,HEAT_MID,0);}const fraction=Math.min(Math.max((value-low)/(high-low),0),1);return fraction<0.5?mix(HEAT_FAST,HEAT_MID,fraction*2):mix(HEAT_MID,HEAT_SLOW,(fraction-0.5)*2);}function mix(from,to,fraction){const channel=index=>Math.round(from[index]+(to[index]-from[index])*fraction);return"rgb(".concat(channel(0),", ").concat(channel(1),", ").concat(channel(2),")");}